import { defineStyleConfig } from "@chakra-ui/react"

const Heading = defineStyleConfig({
    baseStyle: {
        fontFamily: "'Lato'",
        marginBottom: 0
    },
})

export default Heading